import { memoize } from '@exodus/basic-utils';
import { defineSelectorFactory } from '@exodus/redux-dependency-injection';
import { createSelector } from 'reselect';
const selectorFactory = (fiatRatesSelector, createAssetByNameSelector) => memoize((assetName) => createSelector(fiatRatesSelector, createAssetByNameSelector(assetName), (rates, asset) => {
    if (!asset)
        return undefined;
    const ticker = asset.ticker;
    return rates[ticker];
}));
const createAssetRateSelector = defineSelectorFactory({
    id: 'assetRate',
    selectorFactory,
    dependencies: [
        //
        { selector: 'fiatRates' },
        { selector: 'createAssetSelector', module: 'assets' }, // TODO: refactor assets-feature to TypeScript, import actual type
    ],
});
export default createAssetRateSelector;
